import * as React from 'react'

import { Card, Typography } from '@material-ui/core'
import ReactSVG from 'react-svg'
import { Progress } from './Progress'

import { getValueClassName } from 'data/abitilies/Breakpoint'
import InfoIcon from '../../assets/img/info-icon.svg'
import './style.scss'

interface IProps {
  value: number
  maxValue?: number
  title: string
  subTitle?: string
  onClick?: () => void
  openPlusOnlyPopup?: () => void
  plusUser: boolean
}

export class Statistic extends React.Component<IProps> {
  gradStartColor = '#5217B2'
  gradEndColor = '#FF20E9'

  render() {
    const base = 100
    const {
      value,
      maxValue,
      title,
      onClick,
      plusUser,
      openPlusOnlyPopup
    } = this.props

    const max = maxValue || base
    const isDone = value > -1
    const textualScore = getValueClassName(value)

    return (
      <Card className="statistic design-fixes" onClick={onClick}>
        <div className="statistic__left">
          <div className="statistic-text">
            <Typography
              className={
                title === 'Flexible Thinking'
                  ? 'title flexible-thinking-width'
                  : 'title'
              }
              component={'span'}
            >
              {title}
              {plusUser ? (
                <ReactSVG className="info-img" src={InfoIcon} />
              ) : (
                <ReactSVG
                  className="locked-indicator"
                  src={require('../../assets/img/crown.svg')}
                  onClick={() => openPlusOnlyPopup && openPlusOnlyPopup()}
                />
              )}
            </Typography>
          </div>
          {isDone && (
            <div className="sub-title">
              Better than{' '}
              <span className={`percent ${textualScore}`}>{value}%</span> of
              children in age-group
            </div>
          )}
        </div>
        <div className="statistic__right">
          {isDone && (
            <div className={`textual-score ${textualScore}`}>
              <div className="textual-score__text">
                {textualScore.replace('-', ' ')}
              </div>
            </div>
          )}
          <Progress value={(value / max) * base} isHidePrecent={true} />
        </div>
      </Card>
    )
  }
}

export * from './Progress'
export * from './ScoreLegend'



// WEBPACK FOOTER //
// ./src/components/Statistic/index.tsx